export const MILESTONE_BENEFITS_RECEIVED = "MILESTONE_BENEFITS_RECEIVED";
export const SET_MILESTONE_BENEFIT = "SET_MILESTONE_BENEFIT";
export const CREATE_MILESTONE_BENEFIT = "CREATE_MILESTONE_BENEFIT";
export const SET_PROPERTY_MILESTONE_BENEFIT = "SET_PROPERTY_MILESTONE_BENEFIT";
